var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-wrapper-preview", on: { click: _vm.onRemoved } },
    [
      _vm.type === "period"
        ? _c("span", { staticClass: "material-icons mainIcon" }, [
            _vm._v(" date_range "),
          ])
        : _vm.type === "story"
        ? _c("span", { staticClass: "material-icons mainIcon" }, [
            _vm._v(" smart_toy "),
          ])
        : _vm.type === "query"
        ? _c("span", { staticClass: "material-icons mainIcon" }, [
            _vm._v(" format_quote "),
          ])
        : _vm.type === "ignore"
        ? _c("span", { staticClass: "material-icons mainIcon" }, [
            _vm._v(" visibility_off "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "material-icons closeIcon" }, [
        _vm._v(" close "),
      ]),
      _vm._v(" "),
      _c("span", { attrs: { "text-truncate": "", "text-actions": "" } }, [
        _c("span", { attrs: { "text-weight": "semi-bold" } }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.label))]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }